
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround1 as ObiGround1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-1.js';
 
 
 

 
 export const ObiGround1 = createComponent({
   react: React,
   tagName: 'obi-ground-1',
   elementClass: ObiGround1Element,
   events: {
     
   }
  });
 
 